import type { ServiceEntry } from "../../api/platform.service";

export type CatalogRoute = {
  serviceName: string;
  method: string;
  path: string;
  permissions: string[];
};

export type ExistingRoute = {
  serviceName: string;
  method: string;
  path: string;
};

export function routeKey(serviceName: string, method: string, path: string): string {
  return `${serviceName}:${method.toUpperCase()}:${path}`;
}

export function flattenServices(services: ServiceEntry[]): CatalogRoute[] {
  return services.flatMap(service =>
    service.routes.map(route => ({
      serviceName: service.name,
      method: route.method,
      path: route.path,
      permissions: route.permissions,
    })),
  );
}

export function addRouteCandidates(
  catalog: CatalogRoute[],
  existing: ExistingRoute[],
): CatalogRoute[] {
  const existingKeys = new Set(existing.map(r => routeKey(r.serviceName, r.method, r.path)));
  return catalog
    .filter(r => !existingKeys.has(routeKey(r.serviceName, r.method, r.path)))
    .sort((a, b) => `${a.serviceName}${a.path}`.localeCompare(`${b.serviceName}${b.path}`));
}
